import { memo, useCallback, useEffect } from 'react';
import { useDotButton } from '../../hooks/useDotButton';
import { DotNavigationProps } from './DotNAvigation.types';
import type { EmblaCarouselType } from 'embla-carousel';
import Box from '../../../Box/Box';
import { Pressable } from 'react-native';

function DotNavigation({ emblaApi, trackActiveIndex }: DotNavigationProps) {
  const onNavButtonClick = useCallback((emblaApi: EmblaCarouselType) => {
    const autoplay = emblaApi?.plugins()?.autoplay;
    if (!autoplay) return;

    const resetOrStop =
      autoplay.options.stopOnInteraction === false
        ? autoplay.reset
        : autoplay.stop;

    resetOrStop();
  }, []);

  const { selectedIndex, scrollSnaps, onDotButtonClick } = useDotButton({
    emblaApi,
    onNavButtonClick,
  });

  useEffect(() => {
    if (trackActiveIndex) {
      trackActiveIndex(selectedIndex);
    }
  }, [trackActiveIndex, selectedIndex]);

  return (
    <Box position="absolute" bottom="space-200" alignSelf="center">
      <Box
        backgroundColor="screenBackground"
        opacity={0.7}
        borderRadius="radius-full"
        gap="space-200"
        padding="space-200"
        flexDirection="row"
        justifyContent="center"
      >
        {scrollSnaps.map((_, index) => (
          <Pressable key={index} onPress={() => onDotButtonClick(index)}>
            <Box
              cursor="pointer"
              backgroundColor="whiteBackground"
              width={8}
              height={8}
              borderRadius="radius-full"
              padding="space-0"
              opacity={index === selectedIndex ? 1 : 0.5}
            />
          </Pressable>
        ))}
      </Box>
    </Box>
  );
}

export default memo(DotNavigation);
